import { fetcher } from '@commenda/utils';
import { Currency } from '@prisma/client';

export type TUpdateBillingAddressParams = {
  currency?: Currency;
  address: {
    line1: string;
    line2?: string;
    city: string;
    state: string;
    country: string;
    zip: string;
  };
};

export function useUpdateBillingAddress(companyId: number) {
  const update = async (body: TUpdateBillingAddressParams) => {
    if (!companyId) {
      console.error('No company ID provided');
      return;
    }

    const url = `billing-new/contact-info?companyId=${companyId}`;
    const response = await fetcher(url, {
      method: 'POST',
      body: body,
    });

    if (!response.ok) {
      console.error('Failed to update billing address:', response);
      return;
    }

    return response;
  };

  return update;
}
